module.exports = __webpack_public_path__ + "fa-solid-900.376c1f97f6553dea1ca9.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-solid-900.svg
// module id = ../../../../../src/assets/fonts/webfonts/fa-solid-900.svg
// module chunks = styles